// variables global
const html = document.querySelector("html");
const body = document.querySelector("body");

// product variants
const productVariants = document.querySelectorAll('.product-form__input--pill input');

// variables biozid component
const biozidComponent = document.querySelector('.biozid-cmp');
const videoButton = document.getElementById('biozid-video-element');
const buyBotton = document.querySelector('.product-form__buttons button');
const videoLayerButton = document.querySelector('.biozid-cmp__buttons > .biozid-cmp__buttons--ct');
const videoButtonRestart = document.getElementById('biozid-video-element-restart');

// variables biozid layer
const videoLayer = document.querySelector('.biozid-layer');
const closeButton = document.querySelector('.biozid-layer--close');
const videoEl = document.querySelector(".biozid-layer video");
const videoCt = document.querySelector(".biozid-layer__video--ct");
const biozidData = document.querySelector(".biozid-cmp").dataset.biozid;
const posterElement = document.querySelector(".biozid-layer__poster");
const videoLayerWrapper = document.querySelector(".biozid-layer__video-wrapper");
const buyBottonLayer = document.querySelector('.biozid-layer__ready-state--buy button');
const buyBottonLayerMobile = document.querySelector('.biozid-layer__buy-button--mobil button');
const checkboxInputLayer = document.getElementById('biozid-layer-video-checkbox')
const checkboxInputLayerMobile = document.getElementById('biozid-layer-video-checkbox-mobile')

// variables biozid layer controls
const playButton = document.querySelectorAll('.biozid-layer--play');
const pauseButton = document.querySelector('.biozid-layer--pause');
const rewindButton = document.querySelector('.biozid-layer--rewind');
const progressBar = document.querySelector('.biozid-layer--progress-bar');
const timer = document.querySelector('.biozid-layer--timer')
const controls = document.querySelector(".biozid-layer__controls");

// variables biozid layer ready state
const readyState = document.querySelector('.biozid-layer__wrapper')
const readyStateBuyButton = document.querySelector('.biozid-layer__ready-state--buy button')
const restartButton = document.querySelectorAll(".biozid-layer--restart");
const buyButtonMobile = document.querySelector('.biozid-layer__buy-button--mobil')
const checkboxWrapper = document.querySelector('.biozid-cmp__checkbox--wrapper')
const checkboxInput = document.querySelector('.biozid-cmp__checkbox--input')
const checkboxLayer = document.querySelector('.biozid-layer__checkbox--wrapper.biozid-layer__checkbox--mobile')

// add attribute to video element
videoEl.setAttribute('playsinline', '');

// check session storage
checkSessionStorage()
function checkSessionStorage() {
  buyBotton.disabled = true
  const currentSessionStorageArray = JSON.parse(sessionStorage.getItem('biozid'))
  if (currentSessionStorageArray && currentSessionStorageArray.find((el) => !el.hasOwnProperty('state'))) {
    sessionStorage.removeItem('biozid');
  } else if (sessionStorage.getItem("biozid") && sessionStorage.getItem("biozid").includes(biozidData)) {
    videoButton.classList.add('biozid-cmp__buttons--hidden');
    videoButtonRestart.classList.remove('biozid-cmp__buttons--hidden');
    videoLayerButton.classList.add('biozid-cmp__buttons--ready');
    biozidComponent.classList.add('biozid-cmp__buttons--ready');
    checkboxWrapper.classList.add('biozid-cmp__checkbox--active');
    checkboxInput.addEventListener('change', checkboxClickEvent);

    if (currentSessionStorageArray && currentSessionStorageArray.find((el) => el.id === biozidData && el.hasOwnProperty('state') && el.state === true)) {
      checkboxInput.checked = true
      buyBotton.disabled = false
    }
  }
}

productVariants.forEach(element => {
  element.addEventListener('click', variantClick)
})
function variantClick() {
  requestAnimationFrame(() => {
    checkSessionStorage()
  })
  setTimeout(() => {
    checkSessionStorage()
  }, 500)
  setTimeout(() => {
    document.querySelectorAll('.product-form__input--pill input').forEach(element => {
      element.addEventListener('click', variantClick)
    })
  }, 500)
}

// get duration of video
videoEl.addEventListener('loadedmetadata', function() {
  var m = Math.floor(videoEl.duration / 60);
  var s = Math.ceil(videoEl.duration % 60);
  timer.innerHTML = (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s)
});

// timeupdate event - progress bar / timer
videoEl.addEventListener("timeupdate", () => {
  let currentTime = (videoEl.currentTime * 100) / videoEl.duration;
  progressBar.value = currentTime;

  const remainingTime = videoEl.duration - videoEl.currentTime;
  const minutes = Math.floor(remainingTime / 60);
  const seconds = Math.floor(remainingTime % 60);
  timer.innerHTML = (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
});

// open layer button click event
videoButton.addEventListener('click', () => {
  videoLayer.classList.add('biozid-layer--active');
  html.classList.add('biozid-layer--overflow-hidden');
  body.classList.add('biozid-layer--open');
  document.addEventListener('mousemove', mouseMoveDetect);
})
videoButtonRestart.addEventListener('click', () => {
  videoLayer.classList.add('biozid-layer--active');
  html.classList.add('biozid-layer--overflow-hidden');
  body.classList.add('biozid-layer--open');
  document.addEventListener('mousemove', mouseMoveDetect);
})

var timeout;
function mouseMoveDetect() {
  clearTimeout(timeout);
  if (videoCt.classList.contains('biozid-layer--hide-controls')) videoCt.classList.remove('biozid-layer--hide-controls');
  timeout = setTimeout(function () {
    videoCt.classList.add('biozid-layer--hide-controls');
  }, 2000);
}

// close button click event
closeButton.addEventListener('click', () => {
  videoLayer.classList.remove('biozid-layer--active');
  videoEl.pause();

  html.classList.remove('biozid-layer--overflow-hidden');
  body.classList.remove('biozid-layer--open');

  buyButtonMobile.classList.add('biozid-layer--hide');
  checkboxLayer.classList.add('biozid-layer--hide');

  if (readyState.classList.contains('biozid-layer__ready-state--active')) {
    readyState.classList.remove('biozid-layer__ready-state--active');
    controls.classList.remove('biozid-layer--hide');
    posterElement.classList.remove('biozid-layer--ready-state');
    restartButton.forEach(element => {
      element.classList.add('biozid-layer--hide');
    })
  }

  if (!pauseButton.classList.contains('biozid-layer--hide')) {
    playButton.forEach(element => {
      element.classList.remove('biozid-layer--hide');
    });
    pauseButton.classList.add('biozid-layer--hide');
  }

  document.removeEventListener('mousemove', mouseMoveDetect);
})

// play button click event
playButton.forEach(element => {
  element.addEventListener('click', () => {
    playButton.forEach(item => {
      item.classList.add('biozid-layer--hide');
    })
    posterElement.classList.add('biozid-layer--hide');
    pauseButton.classList.remove('biozid-layer--hide');
    videoEl.play();
  })
});

// pause button click event
pauseButton.addEventListener('click', () => {
  playButton.forEach(element => {
    element.classList.remove('biozid-layer--hide');
  })
  //playButton.classList.remove('biozid-layer--hide');
  pauseButton.classList.add('biozid-layer--hide');
  videoEl.pause();
})

// rewind button click event
rewindButton.addEventListener('click', () => {
  videoEl.currentTime = videoEl.currentTime - 10
})

// disable picture in picture
videoEl.disablePictureInPicture = true;

// on tab change
document.addEventListener("visibilitychange", (event) => {
  if (document.visibilityState != "visible" && !readyState.classList.contains('biozid-layer__ready-state--active')) {
    videoEl.pause();

    if (!pauseButton.classList.contains('biozid-layer--hide')) {
      playButton.forEach(element => {
        element.classList.remove('biozid-layer--hide');
      })
      pauseButton.classList.add('biozid-layer--hide');
    }
  }
});

// prevent right click on video element
videoEl.addEventListener('contextmenu', event => event.preventDefault());

// ready state video ended
videoEl.addEventListener("ended", (event) => {
  readyState.classList.add('biozid-layer__ready-state--active');
  //buyBotton.disabled = false
  videoButton.classList.add('biozid-cmp__buttons--hidden');
  videoButtonRestart.classList.remove('biozid-cmp__buttons--hidden');
  checkboxWrapper.classList.add('biozid-cmp__checkbox--active')
  checkboxInput.addEventListener('change', checkboxClickEvent)
  posterElement.classList.remove('biozid-layer--hide');
  buyButtonMobile.classList.remove('biozid-layer--hide');
  controls.classList.add('biozid-layer--hide');
  posterElement.classList.add('biozid-layer--ready-state');
  videoLayerButton.classList.add('biozid-cmp__buttons--ready');
  biozidComponent.classList.add('biozid-cmp__buttons--ready');
  checkboxLayer.classList.remove('biozid-layer--hide')
  restartButton.forEach(element => {
    element.classList.remove('biozid-layer--hide');
  })
  if (sessionStorage.getItem("biozid")) {
    const currentArray = JSON.parse(sessionStorage.getItem('biozid'))
    if (currentArray.find((el) => el.id !== biozidData)) {
      currentArray.push({id: biozidData, state: false})
      let setObj = new Set(currentArray.map(JSON.stringify));
      let currentArrayOutput = Array.from(setObj).map(JSON.parse);
      sessionStorage.setItem('biozid', JSON.stringify(currentArrayOutput));
    }
  } else {
    const array = []
    array.push({id: biozidData, state: false})
    sessionStorage.setItem("biozid", JSON.stringify([...new Set(array)]));
  }
  buyBottonLayer.disabled = true
  buyBottonLayerMobile.disabled = true
  const currentSessionStorageArray = JSON.parse(sessionStorage.getItem('biozid'))
  if (currentSessionStorageArray.find((el) => el.id === biozidData).state === true) {
    checkboxInputLayer.checked = true
    checkboxInputLayerMobile.checked = true
    buyBottonLayer.disabled = false
    buyBottonLayerMobile.disabled = false
  }
  checkboxInputLayer.addEventListener('change', checkboxLayerClickEvent);
  checkboxInputLayerMobile.addEventListener('change', checkboxLayerClickEventMobile);
});

// checkbox click event
function checkboxClickEvent () {
  checkboxInput.checked ? buyBotton.disabled = false : buyBotton.disabled = true

  if (checkboxInput.checked) {
    const currentArray = JSON.parse(sessionStorage.getItem('biozid'))
    const newArray = currentArray.map(element => {
      if (element.id === biozidData) {
        element.state = true
      }
      return element
    })
    sessionStorage.setItem('biozid', JSON.stringify(newArray))
  } else {
    const currentArray = JSON.parse(sessionStorage.getItem('biozid'))
    const newArray = currentArray.map(element => {
      if (element.id === biozidData) {
        element.state = false
      }
      return element
    })
    sessionStorage.setItem('biozid', JSON.stringify(newArray))
  }
}
// checkbox layer click event
function checkboxLayerClickEvent () {
  checkboxInputLayer.checked ? buyBottonLayer.disabled = false : buyBottonLayer.disabled = true

  if (checkboxInputLayer.checked) {
    checkboxInput.checked = true
    buyBotton.disabled = false
    const currentArray = JSON.parse(sessionStorage.getItem('biozid'))
    const newArray = currentArray.map(element => {
      if (element.id === biozidData) {
        element.state = true
      }
      return element
    })
    sessionStorage.setItem('biozid', JSON.stringify(newArray))
  } else {
    checkboxInput.checked = false
    buyBotton.disabled = true
    const currentArray = JSON.parse(sessionStorage.getItem('biozid'))
    const newArray = currentArray.map(element => {
      if (element.id === biozidData) {
        element.state = false
      }
      return element
    })
    sessionStorage.setItem('biozid', JSON.stringify(newArray))
  }
}
function checkboxLayerClickEventMobile () {
  checkboxInputLayerMobile.checked ? buyBottonLayerMobile.disabled = false : buyBottonLayerMobile.disabled = true

  if (checkboxInputLayerMobile.checked) {
    checkboxInput.checked = true
    buyBotton.disabled = false
    const currentArray = JSON.parse(sessionStorage.getItem('biozid'))
    const newArray = currentArray.map(element => {
      if (element.id === biozidData) {
        element.state = true
      }
      return element
    })
    sessionStorage.setItem('biozid', JSON.stringify(newArray))
  } else {
    checkboxInput.checked = false
    buyBotton.disabled = true
    const currentArray = JSON.parse(sessionStorage.getItem('biozid'))
    const newArray = currentArray.map(element => {
      if (element.id === biozidData) {
        element.state = false
      }
      return element
    })
    sessionStorage.setItem('biozid', JSON.stringify(newArray))
  }
}

// ready state buy button
readyStateBuyButton.addEventListener('click', () => {
  videoLayer.classList.remove('biozid-layer--active');
  html.classList.remove('biozid-layer--overflow-hidden');
  body.classList.remove('biozid-layer--open');
})
buyBottonLayerMobile.addEventListener('click', () => {
  videoLayer.classList.remove('biozid-layer--active');
  html.classList.remove('biozid-layer--overflow-hidden');
  body.classList.remove('biozid-layer--open');
})

// restart video
restartButton.forEach(element => {
  element.addEventListener('click', () => {
    
    buyButtonMobile.classList.add('biozid-layer--hide');
    checkboxLayer.classList.add('biozid-layer--hide');

    videoEl.currentTime = 0;
    videoEl.play();
    readyState.classList.remove('biozid-layer__ready-state--active');
    posterElement.classList.add('biozid-layer--hide');
    controls.classList.remove('biozid-layer--hide');
    element.classList.add('biozid-layer--hide');
  })
})

// detect click outside of video layer
videoLayer.addEventListener('click', (event) => {
  if (event.target === videoLayer) {
    videoLayer.classList.remove('biozid-layer--active');
    videoEl.pause();
    html.classList.remove('biozid-layer--overflow-hidden');
    body.classList.remove('biozid-layer--open');
    document.removeEventListener('mousemove', mouseMoveDetect);

    buyButtonMobile.classList.add('biozid-layer--hide');

    if (readyState.classList.contains('biozid-layer__ready-state--active')) {
      readyState.classList.remove('biozid-layer__ready-state--active');
      controls.classList.remove('biozid-layer--hide');
      posterElement.classList.remove('biozid-layer--ready-state');
      restartButton.forEach(element => {
        element.classList.add('biozid-layer--hide');
      })
    }
  
    if (!pauseButton.classList.contains('biozid-layer--hide')) {
      playButton.forEach(element => {
        element.classList.remove('biozid-layer--hide');
      });
      pauseButton.classList.add('biozid-layer--hide');
    }
  }
})